import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { RumComponentContextProvider } from '@mint-lib/datadog';
import { QueryClientProvider } from '@mint-lib/query-client';

import { queryClient } from '../api/queries/main.js';
import ModalProvider from '../context/ModalContext/ModalProvider.jsx';
import App from './App.jsx';

const PermissionsApp = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RumComponentContextProvider componentArea="user-permissions">
        <ModalProvider>
          <App />
        </ModalProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </RumComponentContextProvider>
    </QueryClientProvider>
  );
};

export default PermissionsApp;
